import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "./UseCasesBanner.css";
import { getData } from "app/data";
const Index = ({ except }) => {
  const useCase = [];
  getData("useCaseData")
    .map((item) => {
      if (item.title !== except) useCase.push(item);
    })
   

  return (
    <div className="ViewCaseSection div-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="text-wrapper">
              <div className="table-cell">
                <h1>
                  <FormattedMessage id={"hardware_usecase_title"} />
                </h1>
                <p>
                  <FormattedMessage id={"hardware_usecase_subtitle"} />
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <ul>
            {
              useCase?
              useCase.slice(0,3).map((item) =>(
                <li>
                <Link to={item.link}>
                  <FormattedMessage id={item.title} />
                </Link>
              </li>
              ))
              :null
            }
            </ul>
          </div>

          <div className="col-lg-3">
            <ul>
            {
              useCase?
              useCase.slice(3,useCase.length).map((item) =>(
                <li>
                <Link to={item.link}>
                  <FormattedMessage id={item.title} />
                </Link>
              </li>
              ))
              :null
            }
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
